/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uploading_ShotsInputs */



/**
* | output |
* | --- |
* | "Uploading shot change data..." |
*
* @param {Uploading_ShotsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const uploading_shots = /** @type {((inputs?: Uploading_ShotsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploading_ShotsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des données de changement de plan...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schusswechseldaten werden hochgeladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento dei dati relativi al cambio di inquadratura...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка данных об изменении кадра...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando datos de cambio de toma...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在上传镜头切换数据……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショット変更データをアップロードしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट परिवर्तन डेटा अपलोड किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando dados de alteração de tiro...")
	return /** @type {LocalizedString} */ ("Uploading shot change data...")
});